<template>
    <v-edit-dialog @save="updateAssignedTo" persistent large>
        {{ assigned_to.name }}
        <v-btn icon small class="ml-1">
            <v-icon small color="primary">mdi-pencil</v-icon>
        </v-btn>
        <template v-slot:input>
            <v-select
                :ref="`screeners-${assigned_to.id}`"
                :value="assigned_to.id"
                :items="screeners"
                @change="changeAssignedTo"
                item-text="name"
                item-value="id"
                return-object
            ></v-select>
        </template>
    </v-edit-dialog>
</template>
<script>
export default {
    name: "order-assigned-to",
    components: {},
    props: {
        assigned_to: {
            type: Object,
            required: true,
        },
        screeners: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            assignedToUser: null,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {
        changeAssignedTo(user) {
            this.assignedToUser = user;
        },
        updateAssignedTo() {
            this.$emit("update:assignedTo", this.assignedToUser);
        },
    },
};
</script>

<style scoped>
</style>